import React, { Component } from "react";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import "./BannerColorPicker.css";

class BannerColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerTextColor: props.textColor || "#000000",
      bannerBackground: props.backgroundColor || "#ffffff",
    };
  }

  handleTextColorChange = (event) => {
    const color = event.target.value;
    this.setState({ bannerTextColor: color });
    if (this.props.onTextColorChange) this.props.onTextColorChange(color);
  };

  handleBgColorChange = (event) => {
    const color = event.target.value;
    this.setState({ bannerBackground: color });
    if (this.props.onBackgroundChange) this.props.onBackgroundChange(color);
  };

  render() {
    const { bannerTextColor, bannerBackground } = this.state;

    return (
      <div className="wrapper">
        <div className="color-box-container">
          <input
            type="color"
            value={this.state.bannerTextColor}
            onInput={(e) => {
              this.handleTextColorChange(e);
            }}
            onChange={(e) => {
              this.handleTextColorChange(e);
              e.target.blur();
            }}
            className="color-input"
          />
          <FormatColorTextIcon className="icon-overlay" />
        </div>

        {/* Background Color Picker */}
        <div className="color-box-container">
          <input
            type="color"
            value={bannerBackground}
            onChange={this.handleBgColorChange}
            className="color-input"
          />
          <BorderColorIcon className="icon-overlay" />
        </div>
      </div>
    );
  }
}

export default BannerColorPicker;
